<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jennifer Hunter is a retired mediator who lives in south-eastern Australia. She enjoys working in the garden and growing her own vegetables, baking chocolate desserts, singing pineal tones, and reading. This publication is her first attempt at a little novel and is loosely based upon her spiritual beliefs and experiences.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1a721bb2